module.exports = __webpack_public_path__ + "static/media/produto-mercado.da9462a1.webp";